<script>
export default {
  name: 'LayoutReader'
}
</script>

<template>
  <div :class="$style.layout">
    <Nuxt />
  </div>
</template>

<style lang="scss" module>
.layout {
  @include silent-scroll;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  max-height: 100%;
  max-height: -moz-available;
  max-height: -webkit-fill-available;
  max-height: fill-available;

  @media (min-width: $breakpointTablet) {
    @include scroll;
    overflow-x: hidden;
  }
}
</style>
